import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import { getLocalizedRecordData } from 'src/i18n/localizedContent'
import { useMe } from 'src/services/helpers/user'
import { localeAtom } from 'src/stores/locale'
import { cx } from 'src/utils/cx'
import { QuestCardV2 } from './QuestCardV2'
import { useCategoryDots } from './useQuestDot'
import { useQuestV2Categories, useQuestV2Quests } from './useQuestListV2'

export function QuestInProfileV2() {
  const { beingAdmin } = useMe()
  const [adminView, setAdminView] = useState(false)
  const { categories } = useQuestV2Categories()
  const { questsByCategory, reload } = useQuestV2Quests({
    invisibleQuests: beingAdmin && adminView ? 'include' : undefined,
  })
  const locale = useAtomValue(localeAtom)
  const { hasDot, markCategorySeen } = useCategoryDots(questsByCategory)
  const [activeTab, setActiveTab] = useState('')

  useEffect(() => {
    if (activeTab === '' && categories.length > 0) {
      const firstId = categories[0].id
      setActiveTab(firstId)
      markCategorySeen(firstId)
    }
  }, [categories, activeTab, markCategorySeen])

  const activeQuests = questsByCategory.get(activeTab) ?? []

  if (categories.length === 0) return null

  return (
    <div className="col-span-full">
      {/* Tab bar */}
      <div className="mb-3 flex items-center gap-4">
        {categories.map(cat => {
          const isActive = cat.id === activeTab
          return (
            <button
              key={cat.id}
              type="button"
              className={cx(
                'relative pb-1.5 text-sm font-medium outline-none transition-colors',
                isActive
                  ? 'text-black dark:text-white'
                  : 'text-black/60 dark:text-white/60',
              )}
              onClick={() => {
                setActiveTab(cat.id)
                markCategorySeen(cat.id)
              }}
            >
              <span className="relative">
                {getLocalizedRecordData(locale, cat.label)}
                {hasDot(cat.id) && (
                  <span className="absolute -top-1 -right-2.5 size-2 rounded-full bg-red-500" />
                )}
              </span>
              {isActive && (
                <span className="absolute bottom-0 left-0 h-0.5 w-full bg-black dark:bg-white" />
              )}
            </button>
          )
        })}

        {beingAdmin && (
          <button
            type="button"
            className={cx(
              'ml-auto rounded-md px-2 py-1 text-xs font-medium transition-colors',
              adminView
                ? 'bg-amber-500/20 text-amber-600 dark:text-amber-400'
                : 'bg-zinc-500/10 text-zinc-500',
            )}
            onClick={() => setAdminView(v => !v)}
          >
            {adminView ? 'Admin View' : 'User View'}
          </button>
        )}
      </div>

      {/* Quest grid */}
      <div className="grid grid-cols-1 gap-3 mmd:grid-cols-2 mlg:grid-cols-3">
        {activeQuests.map(quest => (
          <QuestCardV2 key={quest.id} quest={quest} onClaimed={reload} />
        ))}
      </div>
    </div>
  )
}
